function generateDefaultInitialLoadState() {
  return {
    pageType: null,
    dynamic: null,
    domLoadEndTime: null,
    renderStartTime: null,
    renderEndTime: null,
    serverSideRendering: true,
  };
}

function loadReducer(state = generateDefaultInitialLoadState(), action) {
  let newState;

  switch (action.type) {
    case 'SERVER_RENDER_START': {

      newState = {
        ...state,
        serverSideRendering: action?.payload?.params?.serverSideRendering,
      };

      break;
    }

    case 'PAGE_RENDER_START': {

      newState = {
        ...state,
        pageType: action.payload.params.pageType,
        dynamic: action.payload.params.dynamic,
        renderStartTime: new Date().getTime(),
      };

      break;
    }

    case 'DOM_LOADER_END': {

      newState = {
        ...state,
        pageType: action.payload.params.pageType,
        dynamic: action.payload.params.dynamic,
        domLoadEndTime: new Date().getTime(),
      }

      break;
    }

    case 'PAGE_RENDER_END': {
      newState = {
        ...state,
        renderEndTime: new Date().getTime(),
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default loadReducer;
export {generateDefaultInitialLoadState};
